module.exports = __webpack_public_path__ + "static/tiffany-04-8246c756e44ab68bdedb60dbcf7b3cf7.jpg";